import React, { Component } from 'react';
import { Icon } from 'antd';
import { Row, Col, Card, Divider, Input, Form } from 'antd';
import { ssFormUtils, ssFormValidationUtils, ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';
import { fsdoRegConfig } from '../../forms/registration/formConfig';

const
config = fsdoRegConfig,
{ key } = config,
{ generateInitState, generateFormItem, generateInputComponent, setMaxWidth } = ssFormUtils,
{ validateForm, validateSubForm } = ssFormValidationUtils;

let finalCheck = true;
export default class FsdoContactInformation extends Component {
    constructor(props) { 
        super(props);
        this.buildAllFormStates();
    }

    buildAllFormStates() {
        const
        { services } = this.props,
        { storeForm } = services,
        formConfigList = config;
        storeForm('fsdo', formConfigList);
    }

    componentDidUpdate(prevProps) {
        const
        { services, registrationForm } = this.props,
        currForm = registrationForm[key],
        prevForm = prevProps.registrationForm[key],
        { storeForm } = services;

        if(!ssCommonUtils.simpleObjectCompare(prevForm, currForm)) {
            const formState = validateForm(currForm, config, true);
            storeForm(key, formState);
            this.setState({ isValid: validateSubForm(formState) });
        }
    }

    render() {
        const 
        { services, registrationForm } = this.props,
        { storeFormField, storeForm } = services,
        form = registrationForm[key];
        return (
            <div style={{ position: 'fixed', textAlign: 'center', top: '22%', width: '100%' }}>
                <div style={{ textAlign: 'left' }}>
                    <Row type='flex' justify='center'>
                        <Col span={23}>
                            <Divider>
                                <span style={{
                                    color: 'rgb(53, 158, 255)',
                                    fontSize: '12px',
                                    fontWeight: 'bold',
                                    fontStyle: 'italic'
                                }}>
                                    {'Please enter your contact information'}
                                </span>
                            </Divider>
                        </Col>
                    </Row>
                    <Row type='flex' justify='center' style={{ marginTop: '-14px' }}>
                        <Col span={23}>
                            <Row type='flex' justify='center' gutter={12}>
                                <Col span={5}>
                                    <Form.Item {...generateFormItem('firstName', config, form)}>
                                        <Input {...{...generateInputComponent('firstName', config, true, form, storeFormField, storeForm), style: { width: '100%' }}} />
                                    </Form.Item>
                                </Col>
                                <Col span={5}>
                                    <Form.Item {...generateFormItem('middleName', config, form)}>
                                        <Input {...{...generateInputComponent('middleName', config, true, form, storeFormField, storeForm), style: { width: '100%' }}} />
                                    </Form.Item>
                                </Col>
                                <Col span={5}>
                                    <Form.Item {...generateFormItem('lastName', config, form)}>
                                        <Input {...{...generateInputComponent('lastName', config, true, form, storeFormField, storeForm), style: { width: '100%' }}} />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row type='flex' justify='center' gutter={12}>
                                <Col span={5}>
                                    <Form.Item {...generateFormItem('phoneNumber', config, form)}>
                                        <Input {...{...generateInputComponent('phoneNumber', config, true, form, storeFormField, storeForm), style: { width: '100%' }}} />
                                    </Form.Item>
                                </Col>
                                <Col span={5}>
                                    <Form.Item {...generateFormItem('emailAddress', config, form)}>
                                        <Input {...{...generateInputComponent('emailAddress', config, true, form, storeFormField, storeForm), style: { width: '100%' }}} />
                                    </Form.Item>
                                </Col>
                                <Col span={5}>
                                    <Form.Item {...generateFormItem('verifyEmail', config, form)}>
                                        <Input {...{...generateInputComponent('verifyEmail', config, true, form, storeFormField, storeForm), style: { width: '100%' }}} />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </div>
            </div>
        );
    }
}
